/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";
import './Teaser.css';
import voiceConditioningBanner from 'assets/img/mockups/listen-first-banner.png';
import elcarBanner from 'assets/img/mockups/elcar-banner.png';
import { Link } from 'react-router-dom'; 


// reactstrap components
import {
    Button,
    Container,
    Row,
    Col,
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
} from "reactstrap";


class Teaser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
            animating: false,
        };
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.goToIndex = this.goToIndex.bind(this);
    }

    next() {
        if (this.state.animating) return;
        const nextIndex = this.state.activeIndex === this.items.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({ activeIndex: nextIndex });
    }

    previous() {
        if (this.state.animating) return;
        const nextIndex = this.state.activeIndex === 0 ? this.items.length - 1 : this.state.activeIndex - 1;
        this.setState({ activeIndex: nextIndex });
    }

    goToIndex(newIndex) {
        if (this.state.animating) return;
        this.setState({ activeIndex: newIndex });
    }

    items = [
        <Container key={1} className="py-lg-md px-3 px-md-4 px-lg-5 d-flex" fluid>
            <div className="carousel-item-content">
                <Row className="align-items-center justify-content-between w-100">
                    <Col lg="6" md="7" className="order-md-1 content-col">
                        <div className="display-3">
                            <h1>LISTEN FIRST</h1>
                            <h2 className="fs-2 mb-0">Empower Learning for Individuals with Developmental Delays.</h2>
                            <h2 className="fs-2 mt-0" id="action-call">Try the Fred S. Keller Protocol Today!</h2>
                        </div>
                        <div className="btn-wrapper" id="firstlook-buttons">
                            <Link 
                                to="/listen-first" 
                                className="btn btn-primary btn-icon mb-3 mb-sm-0" 
                                id="btn-primary"
                            >
                                <span className="btn-inner--text">Coming soon</span>
                            </Link>
                            <Button
                                className="btn-white btn-icon mb-3 mb-sm-0 ml-1"
                                id="btn-secondary"
                                color="default"
                                href="#products-section"
                                outline
                            >
                                <span className="btn-inner--text">
                                    View Other Products
                                </span>
                            </Button>
                        </div>
                    </Col>
                    <Col lg="6" md="5" className="order-md-2 text-center image-col">
                        <img
                            alt="Listen First"
                            id="fisrtlook-teaser"
                            className="img-fluid floating"
                            src={voiceConditioningBanner}
                        />
                    </Col>
                </Row>
            </div>
            
        </Container>,
        <Container key={2} className="py-lg-md px-3 px-md-4 px-lg-5 d-flex elcar-container" fluid>
            <div className="carousel-item-content">
                <Row className="align-items-center w-100">
                    <Col lg="6" md="6" className="order-md-1 content-col">
                        <div className="display-3">
                            <h1>
                                <span className="letter e">E</span>
                                <span className="letter l">L</span>
                                <span className="letter c">C</span>
                                <span className="letter a">A</span>
                                <span className="letter r">R</span>
                            </h1>
                            <h2 className="fs-2 mb-0">Streamline Your Assessments & Maximize Learning.</h2>
                            <h2 className="fs-2 mt-0" id="action-call-elcar">Get the ELCAR Now!</h2>
                        </div>
                        <div className="btn-wrapper" id="firstlook-buttons">
                            <Link 
                                to="/elcar" 
                                className="btn btn-primary btn-icon mb-3 mb-sm-0" 
                                id="btn-primary-elcar"
                            >
                                <span className="btn-inner--text">Coming soon</span>
                            </Link>
                            <Button
                                className="btn-white btn-icon mb-3 mb-sm-0 ml-1"
                                id="btn-secondary-elcar"
                                color="default"
                                href="#products-section"
                                outline
                            >
                                <span className="btn-inner--text">
                                    View Other Products
                                </span>
                            </Button>
                        </div>
                    </Col>
                    <Col lg="6" md="6" className="order-md-2 text-center image-col">
                        <img
                            alt="ELCAR"
                            id="fisrtlook-teaser-elcar"
                            className="img-fluid floating"
                            src={elcarBanner}
                        />
                    </Col>
                </Row>
            </div>
        </Container>,
    ];
    
    slides = this.items.map((item, index) => (
        <CarouselItem
            onExiting={() => this.setState({ animating: true })}
            onExited={() => this.setState({ animating: false })}
            key={index}
        >
            {item}
        </CarouselItem>
    ));

    render() {
        return (
            <div className="position-relative pt-5 carousel">
                <section className="section section-lg section-shaped pb-10">
                    <Carousel
                        activeIndex={this.state.activeIndex}
                        next={this.next}
                        previous={this.previous}
                    >
                        <CarouselIndicators className="carouselIndicator" items={this.items} activeIndex={this.state.activeIndex} onClickHandler={this.goToIndex} />
                        {this.slides}
                        <CarouselControl className="carouselControler" direction="prev" directionText="Previous" onClickHandler={this.previous} />
                        <CarouselControl className="carouselControler" direction="next" directionText="Next" onClickHandler={this.next} />
                    </Carousel>
                </section>
            </div>
        );
    }
}

export default Teaser;